import { routeData } from "./routes";
import { checkPagePrerequisites } from "@/router/methods/page-prerequisites";
import store from "@/store";

export const autoRouteTable = [
    {
        ...routeData.COVERAGE_STATEMENT,
        isEligible: async () =>
            Boolean(store.getters.order?.isNewInsuranceFlow) &&
            Boolean(store.getters.order?.payment?.insuranceCoverage?.isVerified),
    },
    routeData.QUOTE,
    routeData.CAPABILITY_QUESTIONS,
    routeData.MOLDING_QUESTIONS,
    routeData.VEHICLE_PARTS,
    routeData.PART_QUESTIONS,
    {
        ...routeData.VIN_LOOKUP,
        // Takes over from estimate once damage is captured and a VIN already
        // exists, so returning users skip re-selecting a VIN lookup method.
        isEligible: async () =>
            Boolean(store.getters.vehicle?.vin) &&
            (await checkPagePrerequisites(routeData.ESTIMATE.name)),
    },
    routeData.ESTIMATE,
    routeData.VEHICLE_DAMAGE,
    routeData.VEHICLE,
];
